export enum FEATURES {
  VISIO_RE_SEND_SMS_MAIL = "VisioReSendSmsMailForUnknowPatient",
}
